<template>
  <div id="purchaseOrderChangeInfo">
    <el-row class="clearfix" style="margin-bottom: 15px;">
      <el-col class="fl" :span="2">
        <el-button size="small" type="warning" @click="backGo()">返回</el-button>
      </el-col>
      <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
    </el-row>
    <el-col class="fl searthPart" style="width: 17%;">
      <p class="headerT">采购订单变更信息</p>
      <el-form ref="purchaseForm" :model="purchaseForm" label-width="120px" :label-position="labelPosition">
        <el-form-item label="变更编号:">
          <el-input :disabled="true" v-model="purchaseForm.code">
          </el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(purchaseForm.code,$event)"></i>
        </el-form-item>
        <el-form-item label="作废订单号:">
          <el-input :disabled="true" v-model="purchaseForm.pIdOld" ></el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(purchaseForm.pIdOld,$event)"></i>

        </el-form-item>
        <el-form-item label="新订单号:">
          <el-input :disabled="true" v-model="purchaseForm.pId" ></el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(purchaseForm.pId,$event)"></i>
          
         </el-form-item>
        <el-form-item label="创建时间:">
          <el-input :disabled="true" v-model="purchaseForm.createTime" ></el-input>
         </el-form-item>
        <el-form-item label="状态:">
          <el-input :disabled="true" v-model="purchaseForm.status" ></el-input>
        </el-form-item>
        <el-form-item label="备注信息:">
          <el-input :disabled="true" v-model="purchaseForm.memo" ></el-input>
        </el-form-item>
      </el-form>
      <p class="headerT">变更内容（变更前)</p>
      <el-form ref="purchaseForm" :model="purchaseForm" label-width="120px" :label-position="labelPosition">
        <el-form-item label="供应商:">
          <el-input :disabled="true" v-model="purchaseForm.supplierNameOld" ></el-input>
        </el-form-item>
        <el-form-item label="账期:">
          <el-input :disabled="true" v-model="purchaseForm.paymentTimeOld" ></el-input>
         </el-form-item>
        <el-form-item label="采购日期:">
          <el-input :disabled="true" v-model="purchaseForm.purchaseTimeOld" ></el-input>
        </el-form-item>
        <el-form-item label="预期交货日期:">
          <el-input :disabled="true" v-model="purchaseForm.aogTimeOld" ></el-input>
         </el-form-item>
      </el-form>
      <p class="headerT">变更内容（变更后)</p>
      <el-form ref="purchaseForm" :model="purchaseForm" label-width="120px" :label-position="labelPosition">
        <el-form-item label="供应商:">
          <el-input :disabled="true" v-model="purchaseForm.supplierName" ></el-input>
        </el-form-item>
        <el-form-item label="账期:">
          <el-input :disabled="true" v-model="purchaseForm.paymentTime" ></el-input>
         </el-form-item>
        <el-form-item label="采购日期:">
          <el-input :disabled="true" v-model="purchaseForm.purchaseTime" ></el-input>
        </el-form-item>
        <el-form-item label="预期交货日期:">
          <el-input :disabled="true" v-model="purchaseForm.aogTime" ></el-input>
         </el-form-item>
      </el-form>
    </el-col>
    <el-col class="fr" style="width: 80%;">
      <el-card class="box-card fr" style="width: 100%;">
        <el-table
          :data="returnData"
          border
          :header-cell-style="{'text-align':'center'}"
          :summary-method="getSummaries"
          show-summary
          style="width: 100%">
          <el-table-column
            align="center"
            type="index"
            width="50"
            label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialCoding"
            label="物料编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialName"
            label="物料名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="number"
            label="采购数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            :formatter="addCommas"
            label="采购单价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="amout"
            :formatter="addCommas"
            label="合计金额">
          </el-table-column>
        </el-table>
      </el-card>
      <!--分页-->
      <el-col :span="24" class="toolbar">
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pages.total">
          </el-pagination>
        </div>
      </el-col>
    </el-col>
  </div>
</template>

<script>
  let moment = require("moment");

  import clip from '@/util/clipboard'
  import {
    getpurchasingChangeInfo,
  } from "../../api/api";
  export default {
    name: 'purchaseOrderChangeInfo',
    components: {
    },
    data () {
      return {
        //分页变量
        pages:{
          total: 0,
          page: 1,
          pageSize: 10,
        },
        labelPosition:'left',
        purchaseForm:{
          code: '',
          pIdOld: '',
          pId: '',
          createTime: '',
          status: '',
          memo: '',
          supplierNameOld: '',
          paymentTimeOld: '',
          purchaseTimeOld: '',
          aogTimeOld: '',
          supplierName: '',
          paymentTime: '',
          purchaseTime: '',
          aogTime: '',
        },
        returnData: []
      }
    },
    mounted () {
      // this.getPurchaseOrdersList();
      // console.log(this.orderId)
      if (!this.$route.query.orderId) {
        var userOrderId = sessionStorage.getItem('saveOrderId');
        this.orderId = JSON.parse(userOrderId);
      }else{
        let orderId = this.$route.query.orderId
        this.orderId = orderId
      }
      // console.log(this.orderId)
      this.getPurchasingChangeInfo()
    },
    methods: {
      //获取订单详情
      getPurchasingChangeInfo() {
        let para={
          id: this.orderId,
          startRow: this.pages.page,
          pageSize: this.pages.pageSize
        }
        getpurchasingChangeInfo(para).then(res => {          
          if (res.data.status==100) {            
            this.returnData = res.data.results.purchasingChangeDetails.list
            this.returnData.forEach((item) =>{
              return item.amout = item.price*item.number
            })
            this.purchaseForm = res.data.results.purchasingChangeInfo
            this.purchaseForm.createTime = moment(res.data.results.purchasingChangeInfo.createTime).format("YYYY-MM-DD");
            this.purchaseForm.purchaseTimeOld = moment(res.data.results.purchasingChangeInfo.purchaseTimeOld).format("YYYY-MM-DD");
            this.purchaseForm.aogTimeOld = moment(res.data.results.purchasingChangeInfo.aogTimeOld).format("YYYY-MM-DD");
            this.purchaseForm.purchaseTime = moment(res.data.results.purchasingChangeInfo.purchaseTime).format("YYYY-MM-DD");
            this.purchaseForm.aogTime = moment(res.data.results.purchasingChangeInfo.aogTime).format("YYYY-MM-DD");
           
            sessionStorage.setItem('saveOrderId', JSON.stringify(res.data.results.purchasingChangeInfo.id));
            this.pages.pageSize = res.data.results.purchasingChangeDetails.pageSize
            this.pages.page = res.data.results.purchasingChangeDetails.startRow
            this.pages.total = res.data.results.purchasingChangeDetails.total
            
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //复制内容
      handleCopy(text, event) {
         clip(text, event)
         // console.log('clicp')
      },
      //金额转化函数
      addCommas:function(row,column){
        var num = row[column.property];
        var b= num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        return (((sign)?'':'-') + num + '.' + cents);
      },
      handleSizeChange(val) {
        this.pages.pageSize = val
        this.getPurchasingChangeInfo()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.getPurchasingChangeInfo()
      },
      //返回上一页
      backGo() {
        this.$router.push({
          path:'/purchaseOrderChangeManage'
        })
      },
      refresh() {
        this.getPurchasingChangeInfo()
      },
      toThousands2(num) {
        num = num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        return (((sign)?'':'-') + num + '.' + cents);
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 4) {
            return;
          }
          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = '';
          }
        });
        if (sums[5] > 0) {
          sums[5] = this.toThousands2(sums[5]);
        }
        return sums;
      },      
    },
    computed: {
    },
    watch: {
      
    }
  }
</script>

<style type="text/css" lang="scss" scoped>
  #purchaseOrderChangeInfo{
    font-size: 14px;
    .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
    .el-input{width: 85%;}
    .headerT{font-size: 16px;margin:0 0 15px 0;}
    .activeBtn{background-color: #1abc9c;color:#fff;}
    .el-step__line{background-color: #1abc9c;}
    .el-step__icon-inner{color:#1abc9c;}
    /*.el-step__icon{width: 10px;height: 10px;}*/
    .el-step__icon.is-text{border-color: #1abc9c;}
    .toolbar{margin: 20px 0;}
  }
  
</style>



// WEBPACK FOOTER //
// purchaseOrderChangeInfo.vue?f5e43522